import { ILeadTypeFeedbackSettings } from '../lead-feedback/lead-feedback.entity';

// Lead types (where a lead came from) are a tenant-managed catalogue (table lead_type), no longer
// a hard-coded enum. `code` is the immutable machine key: the website posts it, the vendor feeds
// and the quote flow reference the system codes below. `name` is only the display label.
export interface ILeadTypeEntity {
    lead_type_id: number;
    code: string;
    name: string;
    sequence: number;
    active: boolean;
    // Referenced by code from code (vendor feeds, quote-created leads, the website default, the
    // catch-all for unknown codes): cannot be deleted. Deactivating only hides it from pickers.
    system_managed: boolean;
    data: ILeadTypeData;
    // Read-only: whether any client references this lead type.
    in_use?: boolean;
}

export interface ILeadTypeData {
    // Key of the logo shown on lead cards; absent = no logo.
    logo?: string | null;
    // Lead feedback to the ad platforms; absent = off.
    feedback?: ILeadTypeFeedbackSettings | null;
}

export const SYSTEM_LEAD_TYPE_CODE = {
    bobex: 'bobex',
    solvari: 'solvari',
    manual: 'manual',
    client: 'client',
    website: 'AQUAGROUP_SITE',
    // A lead posted with a code nobody manages is filed here, never silently under another source.
    unknown: 'unknown',
} as const;

export type SystemLeadTypeCode = (typeof SYSTEM_LEAD_TYPE_CODE)[keyof typeof SYSTEM_LEAD_TYPE_CODE];
